<template>
  <span v-if="element">{{element.textFieldValue.value}}</span>
</template>

<script>
export default {
  name: "TextField",
  props: ["element", "entryItems"],
  computed: {
    entryItem() {
      if (!this.entryItems) {
        return undefined;
      }
      return this.entryItems.find(e => e.id == this.element.id);
    }
  },
  data() {
    return { timerId: null };
  },
  methods: {
    changed(e) {
      // debounce
      clearTimeout(this.timerId);
      this.timerId = setTimeout(() => {
        // console.log(value)
        let copy = JSON.parse(JSON.stringify(this.entryItems));
        copy = copy.map(ei => {
          if (ei.id == this.element.id) {
            return { ...ei, stringValue: e.target.value };
          } else {
            return ei;
          }
        });
        this.$emit("updated", copy);
      }, 500);
    }
  }
};
</script>